import { ResolveBaseApiUrl } from "../utils/Utility";
import APIService from "./APIService";

const baseUrl = ResolveBaseApiUrl() + "Misc/";
const miscAPIService = new APIService(baseUrl);

export async function GetDepartments() {
  var url = "getalldepartment";
  return await miscAPIService.fetchData(url);
}

export async function GetCountries() {
  var url = "getallcountry";
  return await miscAPIService.fetchData(url);
}

export async function GetOrderStatus() {
  var url = "getorderstatus";
  return await miscAPIService.fetchData(url);
}

export async function GetFormStatus() {
  var url = "getformstatus";
  return await miscAPIService.fetchData(url);
}

export async function GetStates(countryId) {
  var url = `getstates?countryid=${countryId}`;
  return await miscAPIService.fetchData(url);
}

export async function GetTaxInformation() {
  var url = "gettaxinformation";
  return await miscAPIService.fetchData(url);
}
